export default __webpack_public_path__ + "static/Tele_Lense_16mm_IRcut-f8cd7e68bc75c68bfb2886f09a5c5e28.webp";